import { createContext } from 'react';

const ProjectAppContext = createContext();

export default ProjectAppContext;
